module.exports = __webpack_public_path__ + "media/dogs/dog-digging-0f7b36bc.svg";